export enum CoreEndpoints {
  "CHECK_SESSION" = "/companies/check",
  "COMPANIES" = "/companies",
  "COMPANIES_ONE" = "/companies/one",
  "COMPANIES_ORG" = "/companies/org",
  "ABSENCETYPES" = "/companies/absencetypes",
  "SALARYTYPES" = "/companies/salarytypes",
  "EMPLOYEE_SELF" = "/employees/self",
}
